import {Component} from "@angular/core";
import {TranslateModule} from "@ngx-translate/core";
import {HiddenMapHeader} from "./hidden-map-header/hidden-map-header";

@Component({
  selector: 'hidden-map',
  standalone: true,
  imports: [
    HiddenMapHeader,
    TranslateModule
  ],
  templateUrl: './hidden-map.cmp.html',
  styleUrls: ['./hidden-map.cmp.scss'],
})
export class HiddenMapComponent {
}
